import { useCallback } from 'react';

import { useAppContext } from 'contexts/AppContext/AppContext';
import { DEFAULT_CURRENCY } from 'utils/currency';
import { constructDisplayPrice } from 'utils/general';

export const useHostCurrency = () => {
  const { host } = useAppContext();
  return (host && host.currency) || DEFAULT_CURRENCY;
};

export const useDisplayPrice = () => {
  const currency = useHostCurrency();

  return useCallback((feeAmount, hasPrefix = true) => constructDisplayPrice(feeAmount, hasPrefix, currency), [currency]);
};
